import { TransitionDto } from "@repo/api/transition";
import { AbsoluteFill } from "remotion";
import { preloadVideo } from "@remotion/preload";
import { useEffect } from "react";
import { CompositionTransitionType } from "./components/CompositionTransitionBuilder/CompositionTransitionBuilder.ts";
import CompositionTransitionPreview from "./components/TransitionPreview/CompositionTransitionPreview.tsx";
import TransitionPreviewBackground from "./components/TransitionPreview/TransitionPreviewBackground.tsx";

export type CompositionTransitionCompositionProps = {
  type: CompositionTransitionType;
  transition: TransitionDto;
  clipDurationInFrames: number;
};

const preloadedUrls = new Set<string>();

export const PREVIEW_CLIP_URL = "/transitions/CLIP_1.mp4";

export async function preloadPreviewClip() {
  if (preloadedUrls.has(PREVIEW_CLIP_URL)) {
    return;
  }

  preloadVideo(PREVIEW_CLIP_URL);
  preloadedUrls.add(PREVIEW_CLIP_URL);
}

export default function CompositionTransitionComposition({
  type,
  transition,
  clipDurationInFrames,
}: CompositionTransitionCompositionProps) {
  useEffect(() => {
    preloadPreviewClip();
  }, []);

  return (
    <AbsoluteFill>
      <TransitionPreviewBackground />
      <CompositionTransitionPreview
        transition={transition}
        clipDurationInFrames={clipDurationInFrames}
        type={type}
      />
    </AbsoluteFill>
  );
}
